










import TitleBar from '@/modules/core/components/TitleBar.vue';
import CardComponent from '@/modules/core/components/CardComponent.vue';
import TechnicalMessagesTable from '../components/TechnicalMessagesTable.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    TitleBar,
    CardComponent,
    TechnicalMessagesTable,
  },
})
export default class TechnicalMessageList extends Vue {
  public get titleStack(): string[] {
    return ['Admin', 'Messages techniques'];
  }
}
